const MIN_MATCHABLE_PHONE_DIGITS = 10;
const US_COUNTRY_CODE = "1";

export function matchablePhoneDigits(value: string): string | null {
    const digits = value.replace(/\D/g, "");
    if (digits.length < MIN_MATCHABLE_PHONE_DIGITS) {
        return null;
    }
    if (digits.length === MIN_MATCHABLE_PHONE_DIGITS) {
        return digits;
    }
    if (
        digits.length === MIN_MATCHABLE_PHONE_DIGITS + 1 &&
        digits.startsWith(US_COUNTRY_CODE)
    ) {
        return digits.slice(1);
    }
    return digits;
}

export function matchablePhoneDigitsList(values: string[]): string[] {
    return Array.from(
        new Set(
            values
                .map((value) => matchablePhoneDigits(value))
                .filter((digits): digits is string => digits !== null),
        ),
    );
}

export function matchablePhoneQueryDigits(values: string[]): string[] {
    const queryDigits = new Set<string>();
    for (const canonical of matchablePhoneDigitsList(values)) {
        queryDigits.add(canonical);
        if (canonical.length === MIN_MATCHABLE_PHONE_DIGITS) {
            queryDigits.add(`${US_COUNTRY_CODE}${canonical}`);
        }
    }
    return [...queryDigits];
}
